import {UserService} from '../../user.service';
import {UserStorageService} from '../../storage/user-storage.service';
import {User} from '../../../models/user/user.model';
import {Injectable} from '@angular/core';


@Injectable()
export class AuthService {
    private authenticated: boolean = false;

    constructor(
        private userService: UserService,
        private storage: UserStorageService
    ) {
    }

    /**
     * Setup the identity
     * @param identity
     */
    authenticate(identity) {
        this.storage.set(identity);
        this.authenticated = identity !== null;
    }

    /**
     * Return the account/identity of the current user
     *
     * @param {boolean} force
     * @returns {Promise<User | null>}
     */
    public identity(force?: boolean): Promise<User | null> {
        if (true === force) {
            this.storage.remove();
        }

        const userIdentity = this.storage.get();

        if (userIdentity) {
            return Promise.resolve(userIdentity);
        }

        return this.userService
            .get()
            .toPromise()
            .then(response => {
                const account = response as User;

                if (account) {
                    this.storage.set(account);
                    this.authenticated = true;
                } else {
                    this.storage.remove();
                    this.authenticated = false;
                }

                return account;
            })
            .catch(() => {
                this.storage.remove();
                this.authenticated = false;

                return null;
            });
    }

    public isAuthenticated(): boolean {
        return this.authenticated;
    }
}



// WEBPACK FOOTER //
// ./src/shared/services/security/auth/auth.service.ts